import React from "react";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import TuneIcon from "@mui/icons-material/Tune";
import { ToolbarButton, useGridRootProps } from "@mui/x-data-grid";
import { useAsyncDataGridPresets } from "./AsyncDataGridPresetsContext.js";
import AsyncDataGridPresetsConfigureDialog from "./AsyncDataGridPresetsConfigureDialog.jsx";

/**
 * Toolbar controls for selecting and configuring data grid presets.
 */
function AsyncDataGridPresetsToolbar() {
  const presetsContext = useAsyncDataGridPresets();
  const rootProps = useGridRootProps();
  const TooltipComponent = rootProps.slots.baseTooltip;

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [configureOpen, setConfigureOpen] = React.useState(false);

  if (!presetsContext) {
    return null;
  }

  const { presets, activePresetId, selectPreset } = presetsContext;

  const handleSelectPreset = (preset) => {
    selectPreset(preset);
    setMenuAnchor(null);
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mr: 0.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
          Předvolby
        </Typography>
        <TooltipComponent title="Vybrat předvolbu">
          <ToolbarButton
            aria-label="Vybrat předvolbu"
            onClick={(event) => setMenuAnchor(event.currentTarget)}
            color={activePresetId ? "primary" : "default"}>
            <BookmarkBorderIcon fontSize="small" />
          </ToolbarButton>
        </TooltipComponent>
        <TooltipComponent title="Spravovat předvolby">
          <ToolbarButton aria-label="Spravovat předvolby" onClick={() => setConfigureOpen(true)}>
            <TuneIcon fontSize="small" />
          </ToolbarButton>
        </TooltipComponent>
      </Box>

      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        {presets.length === 0 ? (
          <MenuItem disabled>Žádné předvolby</MenuItem>
        ) : (
          presets.map((preset) => {
            const presetId = String(preset._id);
            const selected = activePresetId === presetId;
            return (
              <MenuItem key={presetId} selected={selected} onClick={() => handleSelectPreset(preset)}>
                {preset.name}
                {preset.isDefault ? " (výchozí)" : ""}
              </MenuItem>
            );
          })
        )}
      </Menu>

      <AsyncDataGridPresetsConfigureDialog open={configureOpen} onClose={() => setConfigureOpen(false)} />
    </>
  );
}

AsyncDataGridPresetsToolbar.propTypes = {};

export default AsyncDataGridPresetsToolbar;
